/**
 * Superadmin Layout
 * Separate layout from the tenant admin dashboard
 */

import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SuperadminSidebar from '../../components/superadmin/SuperadminSidebar';
import TenantsPage from './TenantsPage';
import TenantDetailPage from './TenantDetailPage';
import PlansPage from './PlansPage';
import BillingPage from './BillingPage';
import {
  Bars3Icon,
  XMarkIcon,
  ShieldCheckIcon
} from '@heroicons/react/24/outline';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function SuperadminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <SuperadminSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* Header */}
        <header className="bg-purple-900 text-white px-4 sm:px-6 py-4 flex items-center justify-between flex-shrink-0">
          <div className="flex items-center gap-3">
            <button
              className="lg:hidden text-white/80 hover:text-white"
              onClick={() => setSidebarOpen(true)}
            >
              <Bars3Icon className="w-6 h-6" />
            </button>
            <ShieldCheckIcon className="w-6 h-6 text-purple-300 hidden sm:block" />
            <div>
              <h1 className="text-lg font-bold">Superadmin Panel</h1>
              <p className="text-xs text-purple-300 hidden sm:block">Platform management</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-purple-300 hidden sm:block">
              {user?.firstName} {user?.lastName}
            </span>
            <button
              onClick={() => navigate('/admin')}
              className="text-xs bg-purple-800 hover:bg-purple-700 px-3 py-1.5 rounded-lg transition-colors"
            >
              → Admin
            </button>
            <button
              onClick={handleLogout}
              className="text-xs text-purple-300 hover:text-white"
            >
              Logout
            </button>
          </div>
        </header>

        {/* Content */}
        <main className="flex-1 overflow-x-hidden overflow-y-auto p-4 sm:p-6">
          <Routes>
            <Route path="/" element={<Navigate to="tenants" replace />} />
            <Route path="tenants" element={<TenantsPage />} />
            <Route path="tenants/:id" element={<TenantDetailPage />} />
            <Route path="plans" element={<PlansPage />} />
            <Route path="billing" element={<BillingPage />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
